<template>
  <v-card
    flat
    outlined
    tile
  >
    <v-app-bar
      dense
      flat
    >
      <v-btn
        icon
        color="primary"
        @click.native="goBack()"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>

      <v-toolbar-title>
        {{ store.name }}
        <v-icon
          x-small
          :color="store.live ? 'success' : 'warning'"
        >
          mdi-circle
        </v-icon>
      </v-toolbar-title>

      <v-spacer />

      <v-row
        justify="end"
        no-gutters
      >
        <v-col cols="auto">
          <v-chip
            v-if="store.activeStatus"
            label
            color="success"
            class="mr-2"
          >
            Active
          </v-chip>
          <v-chip
            v-else
            label
            color="error"
            class="mr-2"
          >
            In-active
          </v-chip>
        </v-col>
        <v-col
          v-if="!loader"
          cols="auto"
        >
          <store-options
            :store="store"
            @reload="init()"
          />
        </v-col>
      </v-row>
      <template v-slot:extension>
        <v-tabs centered>
          <v-tabs-slider color="primary" />
          <v-tab
            v-for="tab in tabs"
            :key="tab.name"
            :disabled="tab.disabled"
            @click="changeComponent(tab)"
          >
            {{ tab.name }}
          </v-tab>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                v-bind="attrs"
                v-on="on"
              >
                {{ printerTemplateLabel }}
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-tab>
            </template>

            <v-list class="py-0">
              <v-list-item-group
                v-model="selectedTemplate"
                color="primary"
              >
                <div
                  v-for="template in printerTemplates"
                  :key="`template--${template.name}`"
                >
                  <v-list-item @click="changeComponent(template, true)">
                    {{ template.name }}
                  </v-list-item>
                  <v-divider />
                </div>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-sheet>
      <component
        :is="selectedTab.component"
        v-bind="selectedTab.params"
      />
    </v-sheet>
  </v-card>
</template>

<script>
import { failure } from "@/mixins/common";
import StoreInfo from "./StoreInfo";
import TemplateConfig from "../printerTemplate/Template";
import Contactless from "@/components/store/contactless/Contactless";
import StoreOptions from "@/components/store/StoreOptions";
import OnlinePaymentConfig from "@/components/store/OnlinePaymentConfig";

export default {
  name: "StoreDetails",
  components: {
    StoreInfo,
    TemplateConfig,
    Contactless,
    StoreOptions,
    OnlinePaymentConfig
  },
  mixins: [failure],
  data() {
    return {
      loader: false,
      store: {},
      selectedTab: null,
      printerTemplateLabel: "Printer Templates",
      selectedTemplate: null,
      tabs: [
        {
          name: "Info",
          component: "store-info",
          params: {},
          disabled: false
        },
        {
          name: "Online Payment Configuration",
          component: "online-payment-config",
          params: {},
          disabled: false
        },
        {
          name: "Contactless",
          component: "contactless",
          params: {},
          disabled:
            !this.$store.getters.checkUserPrivilege("STORE_CONTACTLESS")
        }
      ],
      printerTemplates: [
        {
          name: "Receipt Template",
          component: "template-config",
          params: {
            templateType: 1
          },
          disabled: !this.$store.getters.checkUserPrivilege(
            "STORE_TEMPLATE_SETTINGS"
          )
        },
        {
          name: "Digital Receipt Template",
          component: "template-config",
          params: {
            templateType: 5
          },
          disabled: !this.$store.getters.checkUserPrivilege(
            "STORE_TEMPLATE_SETTINGS"
          )
        },
        {
          name: "KOT Template",
          component: "template-config",
          params: {
            templateType: 2
          },
          disabled: !this.$store.getters.checkUserPrivilege(
            "STORE_TEMPLATE_SETTINGS"
          )
        },
        {
          name: "Void KOT Template",
          component: "template-config",
          params: {
            templateType: 3
          },
          disabled: !this.$store.getters.checkUserPrivilege(
            "STORE_TEMPLATE_SETTINGS"
          )
        },
        {
          name: "Bump-out Template",
          component: "template-config",
          params: {
            templateType: 4
          },
          disabled: !this.$store.getters.checkUserPrivilege(
            "STORE_TEMPLATE_SETTINGS"
          )
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    getStore() {
      this.loader = true;
      let storeId = this.$route.params.storeId;
      let url = `${this.ADMIN_API_URL}/stores/${storeId}`;
      this.$http.get(url).then(
        (res) => {
          console.log({ res });
          this.store = res.body;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    goBack() {
      this.$router.push({
        name: "accountInfo",
        params: {
          accountId: this.$route.params.accountId
        }
      });
      localStorage.removeItem("store_info");
    },
    init() {
      this.changeComponent(this.tabs[0]);
      this.getStore();
      this.$store.commit("setTitle", "Store settings");
    },
    changeComponent(tab, printerTemplate = false) {
      this.selectedTab = tab;
      if (printerTemplate) {
        this.printerTemplateLabel = tab.name;
        this.selectedTemplate = tab.params.templateType - 1;
      } else {
        this.printerTemplateLabel = "Printer Templates";
        this.selectedTemplate = null;
      }
    }
  }
};
</script>
